module.exports = __webpack_public_path__ + "posture/static/img/high_low_shoulder_left.9311356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/high_low_shoulder_left.png
// module id = ec1k
// module chunks = 1